export default {
  name: 'Katy Richards',
  title: 'Sr. Account Executive',
  address: '4700 Exchange Ct, Ste 300, Boca Raton, FL  33431',
  phone: '8046147104',
  text: '8046147104',
  email: 'krichards@cinchhs.com',
  brochure: 'https://p.lim.bz/labs/mbc/cinch/files/CNH-MA-GRP1-KR-08-20.pdf',
  facebook: 'https://www.facebook.com/CinchHomeServices/',
  twitter: 'https://www.twitter.com',
  instagram: 'https://www.instagram.com/cinchhomeservices/',
  linkedin: 'https://www.linkedin.com/company/cinch-home-services',
  url: 'http://cinchrealestate.com',
  website: 'cinchrealestate.com',
  legal1: '©2020 Cinch Home Services, Inc. All rights reserved.',
  legal2: 'Cinch is a registered mark of Cinch Home Services, Inc.',
  identifier_id: 17
}